module.exports = __webpack_public_path__ + "img/06.414f50ab.jpg";